'use client'

import React, { ReactNode } from 'react'
import { TABLE_CELL_ROOT_CLASS, TableCell, TableCellProps } from './TableCell'
import { Text } from '../../../atoms'
import { TextTypes } from '../../../../types'

export const TABLE_CELL_DOUBLE_DECKER_TITLE_CLASS = `${TABLE_CELL_ROOT_CLASS}__double-decker-title`

export interface DoubleDeckerTableCellProps extends Omit<TableCellProps, 'title'> {
    title: ReactNode
    reverse?: boolean
}

export const DoubleDeckerTableCell = ({
    title,
    children,
    reverse = false,
    className = '',
    ...props
}: DoubleDeckerTableCellProps) => {
    return (
        <TableCell
            {...props}
            className={`${TABLE_CELL_ROOT_CLASS}--double-decker ${
                reverse ? `${TABLE_CELL_ROOT_CLASS}--double-decker--reverse` : ''
            } ${className}`}
        >
            <Text className={TABLE_CELL_DOUBLE_DECKER_TITLE_CLASS} type={TextTypes.SMALL_TEXT}>
                {title}
            </Text>
            {children}
        </TableCell>
    )
}
